var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable react/no-array-index-key */
/* eslint-disable no-restricted-syntax */
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable react/prop-types */
/* eslint-disable react/no-unused-prop-types */
import React, { useState, useRef, useEffect, } from 'react';
import { makeStyles, createStyles, Button, withStyles, FormControl, FormHelperText, } from '@material-ui/core';
// eslint-disable-next-line import/extensions
import * as XLSX from 'xlsx/dist/xlsx.full.min.js';
import { PlainText } from 'component/LHH/MasterGrids/MasterGrids';
import StyledA from 'component/utility/StyledA';
import { generateRandomString } from '../Table/consts';
// style----------------------------------------------------
export var StyleFormControl = withStyles(function (_a) {
    var palette = _a.palette;
    return ({
        root: {
            padding: '5px',
        },
    });
})(FormControl);
var useStyles = makeStyles(function (theme) {
    return createStyles({
        root: {
            backgroundColor: theme.palette.primary.main,
            color: 'white',
            padding: '6px 16px',
            fontSize: '0.875rem',
            minWidth: '64px',
            boxSizing: 'border-box',
            transition: 'background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,border 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
            fontFamily: "'Roboto', NotoSansTC",
            fontWeight: 500,
            lineHeight: 1.75,
            borderRadius: '4px',
            letterSpacing: '0.02857em',
            textTransform: 'uppercase',
            boxShadow: '0px 3px 1px -2px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 1px 5px 0px rgba(0,0,0,0.12)',
            '&:hover': {
                backgroundColor: theme.palette.primary.dark,
                boxShadow: '0px 2px 4px -1px rgba(0,0,0,0.2), 0px 4px 5px 0px rgba(0,0,0,0.14), 0px 1px 10px 0px rgba(0,0,0,0.12)',
            },
        },
    });
});
export var StyledSpanButton = function (props) {
    var classes = useStyles();
    var text = props.text, other = __rest(props, ["text"]);
    return (React.createElement("span", __assign({ className: classes.root }, other),
        text,
        ' '));
};
export var StyleFormHelperText = withStyles(function (_a) {
    var palette = _a.palette;
    return ({
        root: {
            margin: '5px 14px 0',
        },
    });
})(FormHelperText);
export var FileUpload = function (props) {
    var _a = props.inputRef, inputRef = _a === void 0 ? useRef() : _a, _b = props.verifyBeforeChange, verifyBeforeChange = _b === void 0 ? false : _b, error = props.error, helperText = props.helperText, _c = props.verifiers, verifiers = _c === void 0 ? [] : _c, _file = props._file, _d = props.accept, accept = _d === void 0 ? '.xls,.xlsx' : _d, other = __rest(props, ["inputRef", "verifyBeforeChange", "error", "helperText", "verifiers", "_file", "accept"]);
    var file = _file[0], setFile = _file[1];
    var _e = useState(''), message = _e[0], setMessage = _e[1];
    var _f = useState(verifyBeforeChange), FirstVerify = _f[0], setFirstVerify = _f[1];
    useEffect(function () {
        // 始設畫面預設不 verify , 除非 verifyBeforeChange = true
        if (!FirstVerify) {
            setFirstVerify(true);
            setMessage('');
            return;
        }
        // 驗 HTML validation
        if (inputRef.current && inputRef.current.validationMessage.length > 0) {
            setMessage(inputRef.current.validationMessage);
            return;
        }
        // 驗使用者設定之 verifier, 不驗空值(給 HTML required 驗)
        if (props.value && verifiers.length > 0) {
            for (var _i = 0, verifiers_1 = verifiers; _i < verifiers_1.length; _i++) {
                var obj = verifiers_1[_i];
                if (obj.func(props.value)) {
                    setMessage(obj.text);
                    return;
                }
            }
        }
        // 先前檢驗都 pass
        setMessage('');
    }, [file, verifyBeforeChange]);
    return (React.createElement(StyleFormControl, { error: error || message.length > 0 },
        React.createElement("label", { style: { display: 'flex', alignItems: 'center' } },
            React.createElement(StyledSpanButton, { text: "\u6A94\u6848\u4E0A\u50B3" }),
            React.createElement("input", __assign({ type: "file", accept: accept, ref: inputRef, hidden: true, onChange: function (e) { return setFile(e.target.files[0]); } }, other)),
            React.createElement(PlainText, null, !file ? '請選擇檔案...' : file.name)),
        React.createElement(StyleFormHelperText, null, helperText || message)));
};
export var MultipleFileUpload = function (props) {
    var _a = props.inputRef, inputRef = _a === void 0 ? useRef() : _a, _b = props.verifyBeforeChange, verifyBeforeChange = _b === void 0 ? false : _b, error = props.error, helperText = props.helperText, _c = props.verifiers, verifiers = _c === void 0 ? [] : _c, _uploadFiles = props._uploadFiles, _downloadFiles = props._downloadFiles, _d = props.accept, accept = _d === void 0 ? '.xls,.xlsx' : _d, _e = props.maxSize, maxSize = _e === void 0 ? 10 : _e, _delFiles = props._delFiles, _delUploadedFiles = props._delUploadedFiles, other = __rest(props, ["inputRef", "verifyBeforeChange", "error", "helperText", "verifiers", "_uploadFiles", "_downloadFiles", "accept", "maxSize", "_delFiles", "_delUploadedFiles"]);
    var uploadFiles = _uploadFiles[0], setUploadFiles = _uploadFiles[1];
    var downloadFiles = _downloadFiles[0], getDownloadFile = _downloadFiles[1];
    var delFiles = _delFiles;
    var setDelUploadFiles = _delUploadedFiles;
    var _f = useState(''), message = _f[0], setMessage = _f[1];
    var _g = useState(verifyBeforeChange), firstVerify = _g[0], setFirstVerify = _g[1];
    var _h = useState(false), overSize = _h[0], setOverSize = _h[1];
    useEffect(function () {
        // 始設畫面預設不 verify , 除非 verifyBeforeChange = true
        if (!firstVerify) {
            setFirstVerify(true);
            setMessage('');
            return;
        }
        // 驗 HTML validation
        if (inputRef.current && inputRef.current.validationMessage.length > 0) {
            setMessage(inputRef.current.validationMessage);
            return;
        }
        // 驗使用者設定之 verifier, 不驗空值(給 HTML required 驗)
        if (props.value && verifiers.length > 0) {
            for (var _i = 0, verifiers_2 = verifiers; _i < verifiers_2.length; _i++) {
                var obj = verifiers_2[_i];
                if (obj.func(props.value)) {
                    setMessage(obj.text);
                    return;
                }
            }
        }
        // 先前檢驗都 pass
        setMessage('');
    }, [uploadFiles, verifyBeforeChange]);
    var toBase64 = function (file) {
        return new Promise(function (resolve, reject) {
            var reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = function () { return resolve(reader.result); };
            reader.onerror = function (error) { return reject(error); };
        });
    };
    var updateFile = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        var nowFiles, base64List, i, base64;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    nowFiles = Array.from(e.target.files);
                    if (!(((nowFiles === null || nowFiles === void 0 ? void 0 : nowFiles.length) || 0) +
                        ((uploadFiles === null || uploadFiles === void 0 ? void 0 : uploadFiles.length) || 0) +
                        ((downloadFiles === null || downloadFiles === void 0 ? void 0 : downloadFiles.length) || 0) >
                        maxSize)) return [3 /*break*/, 1];
                    setOverSize(true);
                    return [3 /*break*/, 6];
                case 1:
                    setOverSize(false);
                    base64List = [];
                    i = 0;
                    _a.label = 2;
                case 2:
                    if (!(i < nowFiles.length)) return [3 /*break*/, 5];
                    return [4 /*yield*/, toBase64(nowFiles[i])];
                case 3:
                    base64 = (_a.sent());
                    base64List.push({
                        transactionId: generateRandomString(),
                        content: base64 === null || base64 === void 0 ? void 0 : base64.split(',')[1],
                        fileName: nowFiles[i].name,
                    });
                    _a.label = 4;
                case 4:
                    i++;
                    return [3 /*break*/, 2];
                case 5:
                    setUploadFiles(uploadFiles ? uploadFiles.concat(base64List) : base64List);
                    _a.label = 6;
                case 6: return [2 /*return*/];
            }
        });
    }); };
    return (React.createElement(StyleFormControl, { error: error || message.length > 0 },
        React.createElement("div", { style: {
                display: 'flex',
                alignItems: 'flex-start',
                flexDirection: 'column',
            } },
            React.createElement("label", null,
                React.createElement(StyledSpanButton, { text: "\u6A94\u6848\u4E0A\u50B3" }),
                React.createElement("input", __assign({ type: "file", accept: accept, ref: inputRef, hidden: true, multiple: true, onChange: updateFile }, other))),
            overSize ? React.createElement(PlainText, null, "\u9078\u53D6\u8D85\u904E\u6700\u5927\u6A94\u6848\u6578\u91CF") : React.createElement(React.Fragment, null), downloadFiles === null || downloadFiles === void 0 ? void 0 :
            downloadFiles.map(function (file, key) { return (React.createElement("div", { key: key, style: {
                    display: 'flex',
                    alignItems: 'center',
                    flexDirection: 'row',
                    marginTop: '20px',
                } },
                React.createElement("label", { style: { width: '100px' } },
                    React.createElement(StyledSpanButton, { style: { width: '100%', backgroundColor: 'red' }, text: "\u79FB\u9664\u6A94\u6848" }),
                    React.createElement("input", { accept: accept, ref: inputRef, hidden: true, onClick: function () {
                            setDelUploadFiles(downloadFiles.filter(function (nFile) { return file.transactionId !== nFile.transactionId; }), delFiles
                                ? delFiles.concat(file.transactionId)
                                : [file.transactionId]);
                            setOverSize(((uploadFiles === null || uploadFiles === void 0 ? void 0 : uploadFiles.length) || 0) + ((downloadFiles === null || downloadFiles === void 0 ? void 0 : downloadFiles.length) || 0) >
                                maxSize);
                        } })),
                React.createElement("label", { style: { width: 'calc(100% - 100px)' } },
                    React.createElement(StyledA, { onClick: getDownloadFile(file.fileName) }, file.fileName)))); }), uploadFiles === null || uploadFiles === void 0 ? void 0 :
            uploadFiles.map(function (file, key) { return (React.createElement("div", { key: key, style: {
                    display: 'flex',
                    alignItems: 'center',
                    flexDirection: 'row',
                    marginTop: '20px',
                } },
                React.createElement("label", { style: { width: '100px' } },
                    React.createElement(StyledSpanButton, { style: { width: '100%', backgroundColor: 'red' }, text: "\u79FB\u9664\u6A94\u6848" }),
                    React.createElement("input", { accept: accept, ref: inputRef, hidden: true, onClick: function () {
                            setUploadFiles(uploadFiles.filter(function (nFile) { return file.transactionId !== nFile.transactionId; }));
                            setOverSize(((uploadFiles === null || uploadFiles === void 0 ? void 0 : uploadFiles.length) || 0) + ((downloadFiles === null || downloadFiles === void 0 ? void 0 : downloadFiles.length) || 0) >
                                maxSize);
                        } })),
                React.createElement("label", { style: { width: 'calc(100% - 100px)' } },
                    React.createElement(PlainText, null, file.fileName)))); })),
        React.createElement(StyleFormHelperText, null, helperText || message)));
};
export var MultipleFile = function (props) {
    var _a = props.inputRef, inputRef = _a === void 0 ? useRef() : _a, _b = props.verifyBeforeChange, verifyBeforeChange = _b === void 0 ? false : _b, error = props.error, helperText = props.helperText, _c = props.verifiers, verifiers = _c === void 0 ? [] : _c, _downloadFiles = props._downloadFiles;
    var downloadFiles = _downloadFiles[0], getDownloadFile = _downloadFiles[1];
    var _d = useState(''), message = _d[0], setMessage = _d[1];
    var _e = useState(verifyBeforeChange), firstVerify = _e[0], setFirstVerify = _e[1];
    useEffect(function () {
        // 始設畫面預設不 verify , 除非 verifyBeforeChange = true
        if (!firstVerify) {
            setFirstVerify(true);
            setMessage('');
            return;
        }
        // 驗 HTML validation
        if (inputRef.current && inputRef.current.validationMessage.length > 0) {
            setMessage(inputRef.current.validationMessage);
            return;
        }
        // 驗使用者設定之 verifier, 不驗空值(給 HTML required 驗)
        if (props.value && verifiers.length > 0) {
            // eslint-disable-next-line no-restricted-syntax
            for (var _i = 0, verifiers_3 = verifiers; _i < verifiers_3.length; _i++) {
                var obj = verifiers_3[_i];
                if (obj.func(props.value)) {
                    setMessage(obj.text);
                    return;
                }
            }
        }
        // 先前檢驗都 pass
        setMessage('');
    });
    return (React.createElement(StyleFormControl, { error: error || message.length > 0 },
        React.createElement("div", { style: {
                display: 'flex',
                alignItems: 'flex-start',
                flexDirection: 'column',
            } }, downloadFiles === null || downloadFiles === void 0 ? void 0 : downloadFiles.map(function (file, key) { return (React.createElement("div", { key: key, style: {
                display: 'flex',
                alignItems: 'center',
                flexDirection: 'row',
                marginTop: '20px',
            } },
            React.createElement("label", { style: { width: 'calc(100% - 100px)' } },
                React.createElement(StyledA, { onClick: getDownloadFile(file.fileName) }, file.fileName)))); })),
        React.createElement(StyleFormHelperText, null, helperText || message)));
};
var Style_Button = withStyles({
    root: {
        borderRadius: '20px',
    },
})(Button);
export var ButtonContain = function (props) {
    var children = props.children, other = __rest(props, ["children"]);
    return (
    // eslint-disable-next-line react/jsx-pascal-case
    React.createElement(Style_Button, __assign({ variant: "contained", color: "primary" }, other), children));
};
export var ButtonContainO = function (props) {
    var children = props.children, other = __rest(props, ["children"]);
    return (React.createElement(Button, __assign({ variant: "contained", color: "primary" }, other), children));
};
export var ButtonOutline = function (props) {
    var children = props.children, other = __rest(props, ["children"]);
    return (React.createElement(Button, __assign({ variant: "outlined", color: "primary" }, other), children));
};
var modalOverlayStyle = {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    backgroundColor: 'rgba(0,0,0,0.6)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 10000,
};
var modalContentStyle = {
    backgroundColor: 'white',
    padding: '24px',
    borderRadius: '12px',
    width: '90%',
    maxWidth: '550px',
    boxShadow: '0 10px 25px rgba(0,0,0,0.2)',
};
// 彈跳視窗樣式
var errorListContainerStyle = {
    maxHeight: '350px',
    overflowY: 'auto',
    backgroundColor: '#fffafb',
    border: '1px solid #ffccc7',
    padding: '15px',
    borderRadius: '6px',
    marginBottom: '20px',
};
var errorItemStyle = {
    fontSize: '14px',
    color: '#820014',
    marginBottom: '8px',
    borderBottom: '1px dotted #ffa39e',
    paddingBottom: '4px',
    lineHeight: '1.5',
};
var closeButtonStyle = {
    width: '100%',
    padding: '12px',
    backgroundColor: '#d32f2f',
    color: 'white',
    border: 'none',
    borderRadius: '6px',
    cursor: 'pointer',
    fontWeight: 'bold',
    fontSize: '16px',
};
export var ExcelFileUpload = function (props) {
    var _a = props.inputRef, inputRef = _a === void 0 ? useRef() : _a, _file = props._file, columnRules = props.columnRules, sampleFilePath = props.sampleFilePath, _b = props.maxRows, maxRows = _b === void 0 ? 1000 : _b, maxSizeMB = props.maxSizeMB, _c = props.accept, accept = _c === void 0 ? '.xls,.xlsx' : _c, helperText = props.helperText, error = props.error, other = __rest(props, ["inputRef", "_file", "columnRules", "sampleFilePath", "maxRows", "maxSizeMB", "accept", "helperText", "error"]);
    var file = _file[0], setFile = _file[1];
    var _d = useState([]), excelErrors = _d[0], setExcelErrors = _d[1];
    var _e = useState(false), isModalOpen = _e[0], setIsModalOpen = _e[1];
    var _f = useState(false), isLoading = _f[0], setIsLoading = _f[1];
    var _g = useState([]), expectedTitles = _g[0], setExpectedTitles = _g[1];
    // 1. 初始化抓取範本
    useEffect(function () {
        var fetchSample = function () { return __awaiter(void 0, void 0, void 0, function () {
            var response, arrayBuffer, workbook, worksheet, rows, titles, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, fetch(sampleFilePath)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.arrayBuffer()];
                    case 2:
                        arrayBuffer = _a.sent();
                        workbook = XLSX.read(new Uint8Array(arrayBuffer), {
                            type: 'array',
                        });
                        worksheet = workbook.Sheets[workbook.SheetNames[0]];
                        rows = XLSX.utils.sheet_to_json(worksheet, {
                            header: 1,
                        });
                        if (rows && rows.length > 0) {
                            titles = rows[0]
                                .map(function (t) { return String(t || '').trim(); })
                                .filter(function (t) { return t !== ''; });
                            setExpectedTitles(titles);
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        err_1 = _a.sent();
                        setExcelErrors(['系統錯誤：無法讀取範例檔案結構，請聯繫管理員']);
                        setIsModalOpen(true);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        fetchSample();
    }, [sampleFilePath]);
    var handleFileChange = function (e) {
        var _a, _b;
        var selectedFile = (_a = e.target.files) === null || _a === void 0 ? void 0 : _a[0];
        if (!selectedFile)
            return;
        if (other.onChange)
            other.onChange(e);
        setIsLoading(true);
        setExcelErrors([]);
        // 唯一的錯誤收集桶
        var allErrors = [];
        // --- [階段 1] 基礎檔案檢查 ---
        var allowedTypes = accept
            .split(',')
            .map(function (t) { return t.trim().replace('.', '').toLowerCase(); });
        var fileExtension = (_b = selectedFile.name.split('.').pop()) === null || _b === void 0 ? void 0 : _b.toLowerCase();
        if (!fileExtension || !allowedTypes.includes(fileExtension)) {
            allErrors.push("\u6A94\u6848\u683C\u5F0F\u932F\u8AA4\uFF1A\u76EE\u524D\u50C5\u652F\u63F4 " + accept + " \u683C\u5F0F");
        }
        if (maxSizeMB && selectedFile.size / (1024 * 1024) > maxSizeMB) {
            allErrors.push("\u6A94\u6848\u5927\u5C0F\u8D85\u904E\u9650\u5236\uFF1A\u4E0A\u9650\u70BA " + maxSizeMB + "MB");
        }
        // 如果基礎檢查就有錯，直接彈窗並結束
        if (allErrors.length > 0) {
            setExcelErrors(allErrors);
            setIsModalOpen(true);
            setFile(null);
            setIsLoading(false);
            if (inputRef.current)
                inputRef.current.value = '';
            return;
        }
        // 將 0 轉為 A, 1 轉為 B... 25 轉為 Z, 26 轉為 AA
        var getExcelColumnName = function (index) {
            var columnName = '';
            var i = index;
            while (i >= 0) {
                columnName = String.fromCharCode((i % 26) + 65) + columnName;
                i = Math.floor(i / 26) - 1;
            }
            return columnName;
        };
        var reader = new FileReader();
        reader.onload = function (event) {
            var _a, _b;
            try {
                var data = new Uint8Array((_a = event.target) === null || _a === void 0 ? void 0 : _a.result);
                var workbook = XLSX.read(data, { type: 'array' });
                var sheet = workbook.Sheets[workbook.SheetNames[0]];
                var rows = XLSX.utils.sheet_to_json(sheet, { header: 1 });
                if (!rows || rows.length === 0) {
                    allErrors.push('檔案內容為空，請確認檔案是否有資料');
                }
                else {
                    var actualTitles = rows[0] || [];
                    var contentData = rows.slice(1);
                    var clientTitles = actualTitles
                        .map(function (t) { return String(t || '').trim(); })
                        .filter(function (t) { return t !== ''; }); // 這裡過濾掉空值，確保算的是有效標題
                    // --- [階段 2] 標題與行數檢查 ---
                    if (expectedTitles.length > 0) {
                        // 1. 檢查欄位數量是否完全一致 (不能多也不能少)
                        if (clientTitles.length !== expectedTitles.length) {
                            allErrors.push("\u6B04\u4F4D\u6578\u91CF\u932F\u8AA4\uFF1A\u7BC4\u672C\u70BA " + expectedTitles.length + " \u6B04\uFF0C\u4F46\u5075\u6E2C\u5230 " + clientTitles.length + " \u6B04\u3002");
                        }
                        else {
                            // 2. 數量一致時，才逐一比對標題文字
                            for (var i = 0; i < expectedTitles.length; i++) {
                                if (clientTitles[i] !== expectedTitles[i]) {
                                    // 使用 getExcelColumnName(i) 顯示 A, B, C...
                                    var colLetter = getExcelColumnName(i);
                                    allErrors.push("\u6A19\u984C\u5217\u4E0D\u7B26\uFF1A\u7B2C " + colLetter + " \u6B04\u61C9\u70BA\u300C" + expectedTitles[i] + "\u300D");
                                }
                            }
                        }
                    }
                    if (contentData.length > maxRows) {
                        allErrors.push("\u8CC7\u6599\u7B46\u6578\u904E\u591A\uFF1A\u76EE\u524D\u70BA " + contentData.length + " \u7B46\uFF0C\u4E0A\u9650\u70BA " + maxRows + " \u7B46");
                    }
                    // --- [階段 3] 內容細項掃描 (僅在標題沒錯的情況下執行，避免 index 錯亂) ---
                    if (allErrors.length === 0 && columnRules) {
                        for (var j = 0; j < contentData.length; j++) {
                            var rowIndex = j + 2;
                            for (var i = 0; i < expectedTitles.length; i++) {
                                var title = expectedTitles[i];
                                var rule = columnRules[title];
                                if (!rule)
                                    continue;
                                var cellString = String((_b = contentData[j][i]) !== null && _b !== void 0 ? _b : '').trim();
                                if (rule.required && cellString === '') {
                                    allErrors.push("\u7B2C " + rowIndex + " \u884C [" + title + "]\uFF1A\u6B64\u6B04\u4F4D\u70BA\u5FC5\u586B");
                                }
                                if (cellString !== '' &&
                                    rule.type === 'number' &&
                                    !/^\d+$/.test(cellString)) {
                                    allErrors.push("\u7B2C " + rowIndex + " \u884C [" + title + "]\uFF1A\u683C\u5F0F\u932F\u8AA4\uFF0C\u8ACB\u63D0\u4F9B\u7D14\u6578\u5B57");
                                }
                                if (rule.maxLength && cellString.length > rule.maxLength) {
                                    allErrors.push("\u7B2C " + rowIndex + " \u884C [" + title + "]\uFF1A\u8D85\u904E\u9577\u5EA6\u4E0A\u9650 " + rule.maxLength + " \u5B57");
                                }
                            }
                        }
                    }
                }
                // --- 最終輸出結果 ---
                if (allErrors.length > 0) {
                    setExcelErrors(allErrors);
                    setIsModalOpen(true);
                    setFile(null);
                    if (inputRef.current)
                        inputRef.current.value = '';
                }
                else {
                    setFile(selectedFile);
                    setIsModalOpen(false);
                }
            }
            catch (err) {
                setExcelErrors(['檔案解析過程中發生未知錯誤']);
                setIsModalOpen(true);
                setFile(null);
            }
            finally {
                setIsLoading(false);
            }
        };
        reader.readAsArrayBuffer(selectedFile);
    };
    return (React.createElement(StyleFormControl, { error: error },
        React.createElement("label", { style: { display: 'flex', alignItems: 'center', cursor: 'pointer' } },
            React.createElement(StyledSpanButton, { text: isLoading ? '檢查中...' : '檔案上傳' }),
            React.createElement("input", __assign({}, other, { type: "file", accept: accept, ref: inputRef, hidden: true, onChange: handleFileChange })),
            React.createElement(PlainText, null, !file ? '未選擇檔案' : file.name)),
        isModalOpen && (React.createElement("div", { style: modalOverlayStyle },
            React.createElement("div", { style: modalContentStyle },
                React.createElement("div", { style: {
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        marginBottom: '16px',
                    } },
                    React.createElement("h3", { style: { margin: 0, color: '#d32f2f' } }, "\u26A0\uFE0F \u6A94\u6848\u6AA2\u6838\u8B66\u793A"),
                    React.createElement("span", { style: { fontSize: '12px', color: '#999' } },
                        "\u767C\u73FE ",
                        excelErrors.length,
                        " \u500B\u554F\u984C")),
                React.createElement("div", { style: errorListContainerStyle }, excelErrors.map(function (err, idx) { return (React.createElement("div", { key: idx, style: errorItemStyle },
                    "\u2022 ",
                    err)); })),
                React.createElement("button", { onClick: function () { return setIsModalOpen(false); }, style: closeButtonStyle }, "\u78BA\u8A8D"))))));
};
